module.exports = __webpack_public_path__ + "static/kinds-of-debt-consolidation-loans-bc76c5b1c2f05ee4e134f87fd3f64a26.png";